import { Injectable } from '@angular/core';
import { CallBackActions, OccCallbackService } from '@callback/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class CallbackEffects {
  requestCallback$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CallBackActions.CALLBACK_REQUEST),
      map((action: CallBackActions.CallbackRequest) => action.payload),
      switchMap((data) => {
        return this.occCallbackService.requestCallback(data).pipe(
          map(() => new CallBackActions.CallbackRequestSuccess(data)),
          catchError((error) => of(new CallBackActions.CallbackRequestFail(error))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private occCallbackService: OccCallbackService,
  ) {}
}
